<template>
    <div class="col-md-12">
        <div class="container-fluid bg-light py-3">
            <div class="h2">{{ recurring.name }}</div>
            <div class="flash-message">
                <FlashMessage :position="'top'"></FlashMessage>
            </div>
        </div>
        <form @submit.prevent="updateRecurring">
            <div class="container-fluid bg-light py-3">
                <div class="col-md-6">
                    <div class="form-group">
                        <div><strong>Name</strong></div>
                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                            <input type="text"
                                   required
                                   class="form-control border-0 py-0 shadow-none form-input"
                                   autocomplete="none"
                                   v-model="recurring.name">
                        </div>
                        <br/>
                        <div><strong>Driver</strong></div>
                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                            <v-select :clearable="false"
                                      :options="drivers"
                                      v-model="recurring.driver"
                                      label="name"
                            >
                            </v-select>
                        </div>
                        <br/>
                        <div><strong>Client</strong></div>
                        <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                        >
                            <v-select :clearable="false"
                                      :options="clients"
                                      v-model="recurring.client"
                                      label="name"
                                      @input="getClientAddresses();getClientAgreements()"
                            >
                            </v-select>
                        </div>
                        <br/>
                        <div><strong>Agreement</strong></div>
                        <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                        >
                            <v-select :clearable="false"
                                      :options="agreements"
                                      v-model="recurring.agreement"
                                      @input="getAgreementsProductsServices()"
                                      label="name"
                            >
                            </v-select>
                        </div>

                    </div>
                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Stops</div>
                            <div class="pt-3">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                        <tr>
                                            <th class="border-right text-left">
                                                Stop #
                                            </th>
                                            <th class="border-right text-center">
                                                Address
                                            </th>
                                            <th class="border-right text-center">
                                                Type
                                            </th>
                                            <th>

                                            </th>
                                        </tr>
                                        </thead>
                                        <draggable class="drag" v-model="recurring.stops" tag="tbody">
                                            <tr v-for="(stop,k) in recurring.stops">
                                                <td class="text-center" style="width: 1%">
                                                    {{ k + 1 }}
                                                </td>
                                                <td class="text-center" style="width: 90%">
                                                    {{ stop.addressName }}, {{ stop.addressStreet }},
                                                    {{ stop.addressZip }} {{ stop.addressCity }},
                                                </td>
                                                <td class="text-center" style="width: 8%">
                                                    {{ stop.type == "1" ? 'Pick-up' : 'Drop-off' }}
                                                </td>
                                                <td class="text-center" style="width: 1%">
                                                    <div class="btn float-center btn-default btn-sm"
                                                         @click="deleteStop(k)">
                                                        <div class="material-icons-outlined cursor-pointer text-primary"
                                                             title="delete stop">delete
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </draggable>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Booking info</div>
                            <div class="form-group mb-0">
                                <div class="form-group mb-0 row">
                                    <div class="col-md-4">
                                        <div class="mb-4">
                                            <label for="product-name"
                                                   class="d-block mb-0 font-weight-bold">Products</label>
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="recurring.product==='' && isSubmit? 'border-danger':''">
                                                <select required id="product-name"
                                                        class="form-control border-0 py-0 shadow-none"
                                                        v-model="recurring.agreement_product_id">
                                                    <option v-for="item in products" v-bind:value="item.id">
                                                        {{ item.product.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="mb-4" v-for="type in [tripTypePickup, tripTypeDropoff]">
                                            <label class="d-block mb-0 font-weight-bold">
                                                Services {{ type === tripTypePickup ? 'pickup' : 'dropoff' }}
                                            </label>
                                            <div v-for="item in services" v-if="item.service.type === type">
                                                <label class="newInput">{{ item.service.name }} {{ item.id }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="recurring.agreement_services_ids">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="mb-4" v-for="(agreementAddOns, i) in [agreementAddOnsPickup, agreementAddOnsDropoff]">
                                            <label class="d-block mb-0 font-weight-bold">
                                                Add-ons {{ i === 0 ? 'pickup' : 'dropoff' }}
                                            </label>
                                            <div v-for="item in agreementAddOns">
                                                <label class="newInput">{{ item.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="recurring.agreement_add_on_ids">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-4">
                                        <label class="d-block mb-0 font-weight-bold">Days</label>
                                        <div v-for="(item, k) in daysList">
                                            <label class="newInput">{{ item.name }}
                                                <input
                                                    type="checkbox"
                                                    :value="item.id"
                                                    v-model="recurring.recurring_dates">
                                                <span class="checkmark"></span>
                                            </label>
                                            <input
                                                type="time"
                                                v-model="daysList[k].intervals_from">
                                            -
                                            <input
                                                type="time"
                                                v-model="daysList[k].intervals_to">
                                            <br/> <br/>
                                        </div>

                                    </div>

                                    <div class="col-md-2">
                                        <label class="d-block mb-0 font-weight-bold">Price</label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="recurring.total_price==='' && isSubmit? 'border-danger':''">
                                            <input type="text"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="none"
                                                   v-model="recurring.total_price">
                                        </div>
                                        <br/>

                                        <label class="d-block mb-0 font-weight-bold">Cost price</label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="recurring.cost_price==='' && isSubmit? 'border-danger':''">
                                            <input type="text"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="none"
                                                   v-model="recurring.cost_price">
                                        </div>

                                        <div class="form-group">
                                            <div class="custom-control- custom-checkbox- mb-3">
                                                <label class="custom-control-label-" for="instantly_delivered">
                                                    <b>Mark booking as instantly delivered:</b>
                                                </label>
                                                <input type="checkbox" class="custom-control-input-"
                                                       id="instantly_delivered"
                                                       v-model="recurring.is_instantly_delivered">
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">General info</div>
                            <div>
                                <div class="form-group mb-0">
                                    <div class="form-group mb-0 row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                             <textarea
                                                                 class="form-control"
                                                                 v-model="recurring.internal_comment"
                                                                 placeholder="Note">
                                                              </textarea>
                                            </div>
                                            <br/>

                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Reference"
                                                       autocomplete="none"
                                                       v-model="recurring.reference">
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>

                <div class="row save-recurring">
                    <div class="col-md-4">
                        <button type="submit" class="btn btn-success" @click="validation()">
                            Save
                        </button>
                        <div class="btn btn-primary delete-button" @click="deleteRecurring()">
                            Delete recurring job
                        </div>
                        <br/>
                        <br/>

                        <div v-if="driverJobs.length>0" class="fixed-drivers-height">
                            <div class="h3 mb-3">Other jobs with same driver</div>
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                    <tr>
                                        <th class="border-right text-center">
                                            Name
                                        </th>
                                        <th class="border-right text-center">
                                            Client
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="job in driverJobs">
                                        <td class="text-center">
                                            <a :href="`/recurrings/${job.id}/edit`">{{ job.name }}</a>
                                        </td>
                                        <td class="text-center">
                                            <a :href="`/recurrings/${job.id}/edit`">{{ job.client }}</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </form>
        <form @submit.prevent="toggleModal()">
            <div class="container-fluid py-3 edit-stop">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Add stop</div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <v-select
                                            class="address-select"
                                            :options="clientAddresses"
                                            v-model="newStop.address"
                                            v-on:input="onChangeAddress($event)"
                                            label="value"
                                        >
                                        </v-select>
                                    </div>
                                    <div class="col-md-6">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <vue-google-autocomplete
                                                autocomplete="none"
                                                onfocus="this.setAttribute('autocomplete', 'none');"
                                                id="map2"
                                                types="establishment"
                                                classname="form-control border-0 py-0 shadow-none form-input"
                                                placeholder="Start typing address"
                                                v-on:placechanged="getAddressDataAutocomplete"
                                            >
                                            </vue-google-autocomplete>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressName==='' && isSubmit? 'border-danger':''">
                                            <input type="text"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Full Name"
                                                   autocomplete="none"
                                                   v-model="newStop.addressName">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressStreet==='' && isSubmit? 'border-danger':''">
                                            <input autocomplete="none" required type="text"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Address"
                                                   v-model="newStop.addressStreet">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-4">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressZip==='' && isSubmit? 'border-danger':''">
                                            <input autocomplete="none" required type="text"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Zip"
                                                   v-model="newStop.addressZip"
                                                   @input="getCityByZip($event)"
                                            >
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressCity==='' && isSubmit? 'border-danger':''">
                                            <input autocomplete="none" required type="text"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="City"
                                                   v-model="newStop.addressCity">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressCountryId==='' && isSubmit? 'border-danger':''">
                                            <select class="form-control border-0 py-0 shadow-none pr-5"
                                                    v-model="newStop.addressCountryId">
                                                <option value="1" :selected=true>Denmark</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-8">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.note==='' && isSubmit? '':''">
                                            <input type="text"
                                                   autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Note"
                                                   v-model="newStop.note">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.addressPhone==='' && isSubmit? '':''">
                                            <input type="text"
                                                   autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Phone"
                                                   v-model="newStop.addressPhone">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-8">
                                        <div
                                            class="d-flex align-items-center rounded-lg div-focus">
                                            <button class="btn mb-3 btn-success">
                                                <i class="oi oi-plus" title="add stop"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-4">

                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="newStop.type==='' && isSubmit? 'border-danger':''">
                                            <select
                                                required
                                                class="form-control border-0 py-0 shadow-none pr-5"
                                                v-model="newStop.type">
                                                <option value="1">Pick-up</option>
                                                <option value="2">Drop-off</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Is this stop permanent?
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addPermanentStop">
                            <div class="form-group">
                                <div class="col-md-6">
                                    <select class="form-control"
                                            v-model="permanentStop.isPermanent">
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="permanentStop.isPermanent==0">
                                <div class="form-group">
                                    <div class="">
                                        <div class="col-md-6">
                                            From
                                            <date-picker
                                                required
                                                manual-input
                                                v-model="permanentStop.startDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>

                                        <div class="col-md-6">
                                            To
                                            <date-picker
                                                required
                                                manual-input
                                                v-model="permanentStop.endDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6">
                                        Price
                                        <input type="text"
                                               required
                                               autocomplete="none"
                                               class="form-control"
                                               v-model="permanentStop.price">
                                    </div>
                                </div>
                            </div>

                            <div>
                                <button class="btn btn-success">
                                    Save
                                </button>
                                <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                    Cancel
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import draggable from 'vuedraggable';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import agreementAddOnMixin from "../mixins/agreementAddOnMixin";

export default {
    name: "RecurringEdit",
    props: {
        url: {type: String, required: true},
        driverTypeExternal: {type: Number, required: true},
        userTypeClient: {type: Number, required: true},
        tripTypePickup: {type: Number, required: true},
        tripTypeDropoff: {type: Number, required: true},
    },
    mixins: [datePickerOptionsMixin, agreementAddOnMixin],
    components: {VueGoogleAutocomplete, DatePicker, VueTimepicker, draggable},
    data() {
        return {
            isSubmit: false,
            recurring: {},
            drivers: [
                {id: '', name: ''},
            ],
            clients: [
                {id: '', name: ''},
            ],
            agreements: [
                {id: '', name: ''},
            ],
            products: {},
            services: {},
            daysList: [],
            clientAddresses: [
                {id: '', value: ''},
            ],
            newStop: [],
            driverJobs: [],
            show: false,
            activeModalInterval: false,
            permanentStop: {isPermanent: 0},
            agreementAddOnsPickup: [],
            agreementAddOnsDropoff: []
        }
    },
    methods: {
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.recurring = data.data;
                    this.getAgreementsProductsServices();
                    this.getClientAddresses();
                    this.recurring.agreement_product_id = data.data.agreement_product.id
                    this.driverJobs = data.data.driverJobs
                    this.fillDayList()
                }).catch();
            axios.get('/client-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clients.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch(error => this.clients = []);
            axios.get(`/driver-list?type=${this.driverTypeExternal}`)
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.drivers.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch(error => this.clients = []);
        },
        fillDayList() {
            this.daysList.push({
                id: 1,
                name: 'Monday',
                intervals_from: this.recurring.intervals[0].intervals_from,
                intervals_to: this.recurring.intervals[0].intervals_to
            })
            this.daysList.push({
                id: 2,
                name: 'Tuesday',
                intervals_from: this.recurring.intervals[1].intervals_from,
                intervals_to: this.recurring.intervals[1].intervals_to
            })
            this.daysList.push({
                id: 3,
                name: 'Wednesday',
                intervals_from: this.recurring.intervals[2].intervals_from,
                intervals_to: this.recurring.intervals[2].intervals_to
            })
            this.daysList.push({
                id: 4,
                name: 'Thursday',
                intervals_from: this.recurring.intervals[3].intervals_from,
                intervals_to: this.recurring.intervals[3].intervals_to
            })
            this.daysList.push({
                id: 5,
                name: 'Friday',
                intervals_from: this.recurring.intervals[4].intervals_from,
                intervals_to: this.recurring.intervals[4].intervals_to
            })
            this.daysList.push({
                id: 6,
                name: 'Saturday',
                intervals_from: this.recurring.intervals[5].intervals_from,
                intervals_to: this.recurring.intervals[5].intervals_to
            })
            this.daysList.push({
                id: 7,
                name: 'Sunday',
                intervals_from: this.recurring.intervals[6].intervals_from,
                intervals_to: this.recurring.intervals[6].intervals_to
            })
        },
        getClientAgreements() {
            axios.get(`/client-agreements/${this.recurring.client.id}`)
                .then(({data}) => {
                    this.recurring.agreement_product_id = '';
                    this.recurring.agreement_services_ids = [];
                    this.agreements = [{id: '', name: ''}]
                    this.recurring.agreement = {id: '', name: ''}
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.agreements.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                    if (data.length === 1) {
                        this.recurring.agreement.id = data[0].id;
                        this.recurring.agreement.name = data[0].name;
                        this.getAgreementsProductsServices()
                    }
                }).catch(error => this.agreements = [])
        },
        getAgreementsProductsServices() {
            this.recurring.agreement_product_id = '';
            //this.recurring.agreement_services_ids = [];
            axios.get(`/product-list/${this.recurring.agreement.id}`)
                .then(({data}) => {
                    this.products = data.data;
                    this.recurring.agreement_product_id = data.data[0].id;
                }).catch(error => this.products = [])
            axios.get(`/service-list/${this.recurring.agreement.id}`)
                .then(({data}) => {
                    this.services = data.data;
                }).catch(error => this.services = []);

            this.getAvailableAgreementsAddOns(this.recurring.agreement.id, this.userTypeClient);
        },
        getAddressDataAutocomplete: function (addressData, placeResultData) {
            this.newStop.addressName = placeResultData.name;
            this.newStop.addressStreet = addressData.route + ' ' + addressData.street_number;
            this.newStop.addressZip = addressData.postal_code;
            this.newStop.addressCity = addressData.locality;
            this.newStop.addressCountryId = 1;
        },
        getClientAddresses() {
            axios.get(`/client-addresses/${this.recurring.client.id}`)
                .then(({data}) => {
                    this.clientAddresses = [];
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        const {length} = this.clientAddresses;
                        const id = length + 1;
                        const found = this.clientAddresses.some(el => el.value === `${value.name} ${value.street}, ${value.zip}  ${value.city}, Denmark`);
                        if (!found) this.clientAddresses.push({
                            id: parseInt(value.id),
                            value: `${value.name} ${value.street}, ${value.zip}  ${value.city}, Denmark`,
                            name: value.name,
                            street: value.street,
                            zip: value.zip,
                            city: value.city,
                            type: value.type,
                        });
                    });
                }).catch(error => this.clientAddresses = [])
        },
        getCityByZip: function (event) {
            axios.get(`/get-city-by-zip/${event.target.value}`)
                .then(({data}) => {
                    if (data !== '') {
                        this.newStop.addressCity = data;
                    }
                }).catch();
        },
        onChangeAddress(event) {
            let addressData = this.clientAddresses.filter(p => p.id == event.id);
            if (addressData.length > 0) {
                this.newStop.addressName = addressData[0].name;
                this.newStop.addressStreet = addressData[0].street;
                this.newStop.addressZip = addressData[0].zip;
                this.newStop.addressCity = addressData[0].city;
                this.newStop.addressCountryId = 1;
                this.newStop.type = addressData[0].type;
            }
        },
        addStop() {
            this.recurring.stops.push({
                addressName: this.newStop.addressName,
                addressStreet: this.newStop.addressStreet,
                addressZip: this.newStop.addressZip,
                addressCity: this.newStop.addressCity,
                addressCountryId: 1,
                type: this.newStop.type,
                permanentData: this.permanentStop,
            })
            this.permanentStop = {isPermanent: 0};
        },
        addRecurring() {
            if (this.recurring.driver.id !== '') {
                axios.post('/recurrings', this.recurring).then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Job succesfully created',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((error) => {
                    let errNotify = null;
                    if (error.response) {
                        errNotify = error.response.data;
                    } else if (error.request) {
                        errNotify = error.request;
                    } else {
                        errNotify = error.message;
                    }
                })
            }
        },
        updateRecurring() {
            this.recurring.intervals = this.daysList;
            axios.patch(`/recurrings/${this.recurring.id}`, this.recurring).then((response) => {
                window.location.href = `/recurrings/${this.recurring.id}/edit`;
            }).catch(e => {
                this.validationErrors = e.response.data.errors
            })
        },
        addPermanentStop() {
            this.addStop();
            this.toggleModal();
        },
        deleteStop(k) {
            if (confirm("Are you sure you want to delete this stop")) {
                this.recurring.stops = this.recurring.stops.filter((x, i) => i !== k);
            }
        },
        deleteRecurring() {
            if (confirm("Are you sure you want to delete this recurring booking?")) {
                axios.delete(`/recurrings/${this.recurring.id}`).then((response) => {
                    window.location.href = `/recurrings`;
                }).catch(err => console.log(err))
            }
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        validation() {
            this.isSubmit = true;
        },
    },
    created() {
        return this.fetchData();
    }
}
</script>
<style>
.flash-message {
    z-index: 10000;
    position: absolute;
    top: 105px;
    left: 30%;
    right: 0;
    background-color: #ffffff !important;
    border: none !important;
}

.flash-message p {
    height: 16px;
    /* Label (Small) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    letter-spacing: 0.02em;
    /* Dark Grey */
    color: #777777;
}

._vue-flash-msg-body__title {
    position: relative;
    width: 63px;
    height: 30px;
    left: 46px;
    top: 1px;
}

._vue-flash-msg-body__title:before {
    /* Label (Bold) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    letter-spacing: 0.02em;
    color: #000000;
    content: "Success";
}

._vue-flash-msg-body__text {
    position: relative;
    left: 46px;
    top: 5px;
}

._vue-flash-msg-body__content:before {
    content: url('/checkmark_circle.png');
    left: 5px;
    top: 45%;
    position: relative;
}

.hide-linehaul {
    display: none;
}

.address-select .vs__dropdown-menu {
    width: 600px !important;
}

.edit-stop {
    position: relative;
    bottom: 418px;
}

.save-recurring {
    position: relative;
    top: 500px;
}

.drag {
    cursor: all-scroll;
}

.fixed-drivers-height {
    max-height: 200px;
    overflow-y: auto;
}
</style>

